// icons.js
import ic_active1 from "../img/check/ic_active1.svg";
import ic_active2 from "../img/check/ic_active2.svg";
import ic_active3 from "../img/check/ic_active3.svg";
import ic_active4 from "../img/check/ic_active4.svg";
import ic_active5 from "../img/check/ic_active5.svg";
import ic_active6 from "../img/check/ic_active6.svg";
import ic_active7 from "../img/check/ic_active7.svg";
import ic_active8 from "../img/check/ic_active8.svg";
import ic_active9 from "../img/check/ic_active9.svg";
import ic_active10 from "../img/check/ic_active10.svg";
import ic_active11 from "../img/check/ic_active11.svg";
import ic_active12 from "../img/check/ic_active12.svg";
import ic_active13 from "../img/check/ic_active13.svg";
import ic_active14 from "../img/check/ic_active14.svg";
import ic_active15 from "../img/check/ic_active15.svg";
import ic_active16 from "../img/check/ic_active16.svg";
import ic_active17 from "../img/check/ic_active17.svg";
import ic_active18 from "../img/check/ic_active18.svg";

import backgroundGreen from "../img/background/background_1.png";
import backgroundYe from "../img/background/background_2.png";
import backgroundBlu from "../img/background/background_3.png";
import backgroundPink from "../img/background/background_4.png";
import backgroundTable from "../img/background/background_5.png";
import backgroundSun from "../img/background/background_6.png";
import backgroundRain from "../img/background/background_7.png";
import backgroundPlan from "../img/background/background_8.png";

// 이미지들을 객체로 묶어서 named export로 내보냅니다.
export const activeIcons = {
  ic_active1,
  ic_active2,
  ic_active3,
  ic_active4,
  ic_active5,
  ic_active6,
  ic_active7,
  ic_active8,
  ic_active9,
  ic_active10,
  ic_active11,
  ic_active12,
  ic_active13,
  ic_active14,
  ic_active15,
  ic_active16,
  ic_active17,
  ic_active18,
};

export const backgrounds = [
  backgroundGreen,
  backgroundYe,
  backgroundBlu,
  backgroundPink,
  backgroundTable,
  backgroundSun,
  backgroundRain,
  backgroundPlan,
];
